import request from '@/utils/request'
let ExpressApi = {
    /*订单列表*/
    orderlist(data) {
        return request._post('/shop/plus.express/index', data);
    },
    getExpressTrack(data) {
        return request._post('/shop/plus.express/track', data);
    },
    refreshExpressTrack(data) {
        return request._post('/shop/plus.express/refresh', data);
    },
}

export default ExpressApi;



// WEBPACK FOOTER //
// ./src/api/express.js